const DEFAULT_SCOPE = 'api://d3fc0fb8-3733-4ca6-86d0-dfcc842334b5/access_as_user';

export function getEntraTenantId() {
  return String(process.env.REACT_APP_ENTRA_TENANT_ID || '').trim();
}

export function getEntraClientId() {
  return String(process.env.REACT_APP_ENTRA_CLIENT_ID || '').trim();
}

export function getEntraAuthority() {
  const explicit = String(process.env.REACT_APP_AUTHORITY || '').trim();
  if (explicit) return explicit.replace(/\/$/, '');
  const tenant = getEntraTenantId();
  return tenant ? `https://login.microsoftonline.com/${tenant}` : '';
}

export function getEntraRedirectUri() {
  const explicit = String(process.env.REACT_APP_REDIRECT_URI || '').trim();
  if (explicit) return explicit;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/auth/callback`;
  }
  return '';
}

export function getEntraPostLogoutRedirectUri() {
  const explicit = String(process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || '').trim();
  if (explicit) return explicit;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/signin`;
  }
  return '/signin';
}

export function getEntraApiScope() {
  return String(process.env.REACT_APP_API_SCOPE || DEFAULT_SCOPE).trim();
}

export function isEntraConfigured() {
  const enabled = String(process.env.REACT_APP_ENTRA_ENABLED || 'true')
    .trim()
    .toLowerCase();
  if (enabled === 'false' || enabled === '0' || enabled === 'off') {
    return false;
  }
  return Boolean(getEntraClientId() && getEntraTenantId());
}

export function getMsalConfig() {
  return {
    auth: {
      clientId: getEntraClientId(),
      authority: getEntraAuthority(),
      redirectUri: getEntraRedirectUri(),
      postLogoutRedirectUri: getEntraPostLogoutRedirectUri(),
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
}

export function getEntraLoginRequest() {
  return {
    scopes: [getEntraApiScope()],
  };
}
